import ivrSetting from './ivr-setting'
import ivrInfo from './ivr-info'

export {
    ivrInfo,
    ivrSetting,
}